import {useCallback} from 'react'
import type {TDateFormat} from '../utils/dateUtil'
import {userSelectors} from '../store/user/userSelectors'
import {dateUtil} from '../utils/dateUtil'

export type TFormatDate = (
  date: Date | string | number | null | undefined,
  dateFormat?: TDateFormat,
  timeZone?: string,
) => string

// Binds date formatting to the current user's language, so components don't each
// have to read the store and thread a language argument through every call site.
// Pass timeZone: 'UTC' where the calendar day is the data rather than a moment
// in the viewer's day — see the note on dateUtil.formatDate.
export const useFormatDate = (): TFormatDate => {
  const selectedLanguage = userSelectors.useSelectedLanguage()

  return useCallback<TFormatDate>(
    (date, dateFormat, timeZone) =>
      dateUtil.formatDate(date, dateFormat, selectedLanguage, timeZone),
    [selectedLanguage],
  )
}
